var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.preloader)?_c('v-preloader',{staticClass:"_page"}):(_vm.viewPage)?_c('router-view'):_c('v-error',{attrs:{"title":_vm.$t('modules.pages')['Error'],"subtitle":_vm.$t('modules.pages')['No access to projects']}})
}
var staticRenderFns = []

export { render, staticRenderFns }